import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { addGroupMember, postCreateGroup } from "./MessageService";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import "react-loading-skeleton/dist/skeleton.css";
import Skeleton from "react-loading-skeleton";
import * as Yup from "yup";
import { useFormik } from "formik";
import { uploadDoc } from "../../../Services/Global-Services/GlobalServices";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { MultiSelect } from "primereact/multiselect";
import UploadFile_KEYS from "../../../Services/Global-Services/UploadFile_Keys";
import ImageCropperModal from "../../../Services/Comment/ImageCropperModal";
const defaultImage = "/images/placeholder_profile.png";

const MessageGroup = ({ currentPage, currentGroupEdit }) => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [IsImageloading, setIsImageloading] = useState(false);
  const toster = useContext(TostMsg);
  const [selectedEmployees, setSelectedEmployees] = useState(null);
  const [employeDetails, setEmployeeDetails] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showCropper, setShowCropper] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [acceptRatio, setAcceptRatio] = useState(0);
  const fileInputRef = useRef(null);

  useEffect(() => {
    fetchEmployeeData();
  }, []);

  useEffect(() => {}, [selectedEmployees]);

  useEffect(() => {
    const groupFromValue = {
      GroupName: currentGroupEdit[0]?.GroupName,
      GroupDesc: currentGroupEdit[0]?.GroupDesc,
      IconLogo: currentGroupEdit[0]?.IconLogo,
      CanMemberLeave: currentGroupEdit[0]?.CanMemberLeave,
    };
    CreateGroupForm.setValues(groupFromValue);
    const matchedMembers = employeDetails
      ?.map((emp) => {
        const groupInfo = currentGroupEdit?.find(
          (group) => group.MemberId === emp.EmpId
        );
        if (groupInfo) {
          return {
            ...emp,
          };
        }
        return null;
      })
      .filter(Boolean);
    if (matchedMembers) {
      const membersToRemove = currentGroupEdit
        .filter(
          (member) => member.IsAdmin && member.MemberId === member.OwnerId
        )
        .map((member) => member.MemberId);
      const updatedOriginalArray = matchedMembers.filter(
        (user) => !membersToRemove.includes(user.EmpId)
      );
      setSelectedEmployees(updatedOriginalArray);
    } else {
      CreateGroupForm.setFieldValue("CanMemberLeave", false);
    }
  }, [employeDetails, currentGroupEdit]);

  const changePageType = () => {
    currentPage("groupType");
  };

  const GroupsValidation = Yup.object().shape({
    GroupName: Yup.string().required("Group name is required"),
    GroupDesc: Yup.string().required("Group purpose is required"),
    IconLogo: Yup.string(),
    CanMemberLeave: Yup.boolean(),
  });
  const CreateGroupForm = useFormik({
    initialValues: {
      GroupName: "",
      GroupDesc: "",
      IconLogo: "",
      CanMemberLeave: "",
    },
    validationSchema: GroupsValidation,
    onSubmit: async (data) => {
      if (selectedEmployees.length > 1) {
        let params = {
          Id: currentGroupEdit[0]?.GroupId ?? 0,
          GroupName: data?.GroupName,
          GroupDesc: data?.GroupDesc,
          IconLogo: data?.IconLogo ?? "",
          CanMemberLeave: data?.CanMemberLeave ?? false,
        };
        try {
          const groupData = await postCreateGroup(params);
          const empIdsString = selectedEmployees
            .map((emp) => emp.EmpId)
            .join(",");
          if (groupData) {
            const params = {
              GroupId:
                currentGroupEdit[0]?.GroupId ?? groupData?.Data?.Data[0]?.ToId,
              MemberId: empIdsString,
            };
            const memberData = await addGroupMember(params);
            if (memberData) {
              CreateGroupForm.resetForm();
              if (currentGroupEdit.length > 0) {
                toster.current.success("Group updated successfully");
              } else {
                toster.current.success("Group created successfully");
              }
              currentPage("groupType");
              setSelectedEmployees(null);
              CreateGroupForm.resetForm();
            }
          }
        } catch (err) {
          toster.current.error(ERROR_LIST?.CreateGroup);
        }
      } else {
        toster.current.warn("Please add atleat two member");
      }
    },
  });

  const handleFileChange = async (event, type) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageSrc(reader.result);
        setShowCropper(true);
        setAcceptRatio(1 / 1);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCropComplete = (croppedBlob) => {
    uploadPolicyDocFile([
      new File([croppedBlob], "cropped.jpg", { type: "image/jpeg" }),
    ]);
  };

  async function uploadPolicyDocFile(file) {
    if (file) {
      setIsImageloading(true);
      const formData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formData.append("files", file[i]);
      }
      let params = {
        UploadType: UploadFile_KEYS?.Message,
        RefId: currentGroupEdit[0]?.GroupId ?? 0,
      };
      try {
        const response = await uploadDoc(params, formData);
        const data = await response;
        const ImageURL = data?.Data;
        CreateGroupForm.setFieldValue("IconLogo", ImageURL[0]);
      } catch (error) {
        toster.current.error(ERROR_LIST.UploadFileError);
      } finally {
        setIsImageloading(false);
      }
    } else {
      setIsImageloading(false);
      toster.current.warn("No file selected");
    }
  }

  async function fetchEmployeeData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    try {
      let employeesList = await getEmployeeList(params);
      let empData = employeesList?.Data?.filter(
        (item) => item.Id !== userDetails.EmpId
      );
      const membersToRemove = currentGroupEdit
        .filter((member) => member.IsAdmin)
        .map((member) => member.MemberId);
      const updatedOriginalArray = empData.filter(
        (user) => !membersToRemove.includes(user.EmpId)
      );
      setEmployeeDetails(updatedOriginalArray);
    } catch (error) {}
  }

  const employeeOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage alt={option.FullName} src={option.ProfileImage} width="32" />
        <span>{option.FullName}</span>
      </div>
    );
  };

  const hideSelectedValueTemplate = () => {
    return null;
  };

  const removeFormData = () => {
    // setSelectedEmployees(null);
    currentPage("groupType");
    CreateGroupForm.resetForm();
  };

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  return (
    <>
      <div className="col-md-9 pl-0">
        <div className="tab-content new-messages-group" id="v-pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="v-pills-home"
            role="tabpanel"
            aria-labelledby="v-pills-home-tab"
            tabIndex={0}
          >
            <div className="create-new-wrap">
              <div className="top-headingtitile">
                {currentGroupEdit.length === 0 && <h3>Create New Group</h3>}
                {currentGroupEdit.length !== 0 && <h3>Edit Group</h3>}
                <div className="grp-info">
                  <a onClick={() => changePageType()}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={16}
                      height={16}
                      fill="currentColor"
                      className="bi bi-arrow-left"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div className="addnew-form">
                <form onSubmit={CreateGroupForm.handleSubmit}>
                  <div className="row justify-content-center">
                    <div className="col-md-8">
                      {showCropper && imageSrc && (
                        <ImageCropperModal
                          image={imageSrc}
                          onCropComplete={handleCropComplete}
                          onClose={() => setShowCropper(false)}
                          acceptRatio={acceptRatio}
                        />
                      )}
                      <div className="form-group">
                        <div className="avatar-upload">
                          <div className="avatar-edit">
                            <input
                              ref={fileInputRef}
                              name="IconLogo"
                              type="file"
                              id="file-upload"
                              className="form-control"
                              accept="image/png, image/gif, image/jpeg"
                              onChange={(event) => handleFileChange(event)}
                            />
                            {CreateGroupForm.values?.IconLogo &&(<label htmlFor="file-upload" />)}
                            {!CreateGroupForm.values?.IconLogo &&(<span htmlFor="file-upload" title="Add Group Icon"
                                className="add-membersvg"
                                style={{ cursor: "pointer" }}
                                onClick={() => fileInputRef.current && fileInputRef.current.click()}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={30}
                                  height={30}
                                  fill="currentColor"
                                  className="bi bi-plus"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                                </svg>
                              </span>)}
                          </div>
                          {IsImageloading ? (
                            <Skeleton
                              height={200}
                              width="100%"
                              borderRadius={100}
                            />
                          ) : (
                            <>
                              {CreateGroupForm.values?.IconLogo && (
                                <div className="avatar-preview">
                                  <div
                                    id="imagePreview"
                                    style={{
                                      backgroundImage: `url(${JSON?.stringify(
                                        CreateGroupForm.values?.IconLogo
                                      )})`,
                                    }}
                                  ></div>
                                </div>
                              )}
                              {!CreateGroupForm.values?.IconLogo && (
                                <div className="avatar-preview">
                                  <div
                                    id="imagePreview"
                                    style={{
                                      backgroundImage: `url("/images/menu-icon/group-dp.png")`,
                                      backgroundColor: "gray",
                                      backgroundSize: "cover",
                                      backgroundPosition: "center",
                                      backgroundRepeat: "no-repeat",
                                    }}
                                  ></div>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Group Name</label>
                          <input
                            name="GroupName"
                            value={CreateGroupForm.values.GroupName}
                            onChange={CreateGroupForm.handleChange}
                            onBlur={CreateGroupForm.handleBlur}
                            type="text"
                            className={
                              "form-control" +
                              (CreateGroupForm.errors.GroupName &&
                              CreateGroupForm.touched.GroupName
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <div
                            className="invalid-feedback"
                            style={{ textAlign: "start", marginBottom: "1rem" }}
                          >
                            {" "}
                            {CreateGroupForm.errors.GroupName &&
                            CreateGroupForm.touched.GroupName
                              ? CreateGroupForm.errors.GroupName
                              : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Group Purpose</label>
                          <textarea
                            rows="2"
                            cols="2"
                            name="GroupDesc"
                            className={
                              "form-control h-auto" +
                              (CreateGroupForm.errors.GroupDesc &&
                              CreateGroupForm.touched.GroupDesc
                                ? " is-invalid"
                                : "")
                            }
                            onChange={CreateGroupForm.handleChange}
                            onBlur={CreateGroupForm.handleBlur}
                            value={CreateGroupForm.values.GroupDesc}
                          />
                          <div
                            className="invalid-feedback"
                            style={{ textAlign: "start", marginBottom: "1rem" }}
                          >
                            {" "}
                            {CreateGroupForm.errors.GroupDesc &&
                            CreateGroupForm.touched.GroupDesc
                              ? CreateGroupForm.errors.GroupDesc
                              : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group form-checkcss">
                          <input
                            type="checkbox"
                            name="CanMemberLeave"
                            checked={CreateGroupForm.values.CanMemberLeave}
                            onChange={(e) =>
                              CreateGroupForm.setFieldValue(
                                "CanMemberLeave",
                                e.target.checked
                              )
                            }
                            className={
                              "form-control" +
                              (CreateGroupForm.errors.CanMemberLeave &&
                              CreateGroupForm.touched.CanMemberLeave
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <label htmlFor="CanMemberLeave">
                            Are members allowed to exit?
                          </label>
                        </div>
                        <div className="invalid-feedback">
                          {" "}
                          {CreateGroupForm.errors.CanMemberLeave &&
                          CreateGroupForm.touched.CanMemberLeave
                            ? CreateGroupForm.errors.CanMemberLeave
                            : null}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Group Members</label>
                          <div className="member-list">
                            <div className="row">
                              <ul>
                                {selectedEmployees?.map((emp, index) => (
                                  <li key={index}>
                                    <img
                                      src={emp.ProfileImage || defaultImage}
                                      onError={handleImageError}
                                      alt={emp.FullName}
                                    />
                                    <span>{emp.FullName}</span>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={16}
                                      height={16}
                                      fill="currentColor"
                                      className="bi bi-x"
                                      viewBox="0 0 16 16"
                                      onClick={() => {
                                        setSelectedEmployees(
                                          selectedEmployees.filter(
                                            (e) => e !== emp
                                          )
                                        );
                                      }}
                                    >
                                      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                    </svg>
                                  </li>
                                ))}
                              </ul>
                            </div>
                            {!showDropdown && (
                              <a
                                className="add-membersvg"
                                onClick={() => setShowDropdown(!showDropdown)}
                                style={{ cursor: "pointer" }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={16}
                                  height={16}
                                  fill="currentColor"
                                  className="bi bi-plus"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                                </svg>
                              </a>
                            )}
                            {showDropdown && (
                              <div className="card flex justify-content-center">
                                <MultiSelect
                                  value={selectedEmployees}
                                  onChange={(e) =>
                                    setSelectedEmployees(e.value)
                                  }
                                  options={employeDetails}
                                  optionLabel="FullName"
                                  filter
                                  placeholder="Select Employee"
                                  maxSelectedLabels={0}
                                  selectedItemsLabel="{0} members selected"
                                  className="w-full md:w-20rem custom-multiselect-message"
                                  itemTemplate={employeeOptionTemplate}
                                  // valueTemplate={hideSelectedValueTemplate}
                                  display="chip"
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="actions-btn">
                          <button
                            onClick={() => removeFormData()}
                            className="cancelbtn-click"
                          >
                            Discard
                          </button>
                          <button type="submit" className="savebtn-click">
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default MessageGroup;
